import { getAuthToken } from "../../../auth/authClient";

const API_BASE = (process.env.REACT_APP_MORFEUSZ_4E_API_URL || "").replace(/\/$/, "");
const contactUrl = (path) => `${API_BASE}/contact/${path}`;

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.ok) {
    const error = new Error(data?.message || `contact-http-${response.status}`);
    error.code = data?.code || `contact-http-${response.status}`;
    error.status = response.status;
    throw error;
  }
  return data;
};

export const contactClient = {
  submit: async (payload) => {
    if (!API_BASE) {
      const error = new Error("contact-api-missing");
      error.code = "contact-api-missing";
      throw error;
    }

    const token = getAuthToken();
    const response = await fetch(contactUrl("submit"), {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload || {}),
    });
    return parseResponse(response);
  },
};
